


















import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InsertMessage } from "../models/insert-message";
import { Type } from "../models/message";

const store = namespace("contact");

@Component
export default class ContactForm extends Vue {
  @store.State visible!: boolean;
  @store.State type!: Type | "";

  private message: InsertMessage = {
    body: "",
    type: "",
  };

  private get description(): string {
    if (this.type === "") return "";
    return this.$t("contact.descriptions." + this.type) as string;
  }

  private async emitInput(): Promise<void> {
    if (this.visible && (await this.$validator.validateAll())) {
      this.$emit("input", this.message);
    } else {
      this.$emit("input", null);
    }
    if (!this.visible) {
      this.$validator.reset();
    }
  }

  @Watch("type")
  private onType(t: Type | ""): void {
    this.message.type = t;
  }

  @Watch("message", { deep: true })
  private onMessage(): void {
    this.emitInput();
  }

  @Watch("visible")
  private onVisible(v: boolean, old: boolean): void {
    if (v !== old) this.$validator.reset();

    if (v) return;

    this.message.body = "";
  }
}
